import React from 'react';
import PropTypes from 'prop-types';
import InnerHTML from '@Components/InnerHTML';
import SpiderChartComponent from '@Components/Results/utils/spider-chart.component';

export default class SubstanceDruglikenessComponent extends React.PureComponent {
  render() {
    const {
      drugData,
      drugData: { graph },
    } = this.props;
    const listOfValues = graph ? graph.data.reduce((memo, { data }) => memo.concat(data), []) : [];
    const calcScale = Math.ceil(Math.max(...listOfValues) / 10);

    return (
      <div className="rx-element--druglikeness-data clearfix o-els-flex-layout o-els-flex-layout--left o-els-flex-layout--wrap@mobile">
        <div className="col u-els-margin-left-1x1o2">
          {drugData.tableData
            ? drugData.tableData.map((item, index) => (
                <table className="rx-table rx-table--fixed" key={item.title || index}>
                  <colgroup>
                    <col className="rx-table__col--half" />
                    <col className="rx-table__col--half" />
                  </colgroup>
                  <thead>
                    <tr>
                      <th scope="col" colSpan="2">
                        <strong>{item.title}</strong>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {item.children
                      ? item.children.map((child, childIndex) => (
                          <tr key={child.id || childIndex}>
                            <InnerHTML tag="th" scope="row" html={child.title} />
                            <InnerHTML tag="td" html={child.value} />
                          </tr>
                        ))
                      : null}
                  </tbody>
                </table>
              ))
            : null}
        </div>
        {graph && <SpiderChartComponent className="col flex-grow" categories={graph.labels} series={graph.data} tickInterval={calcScale} />}
      </div>
    );
  }
}

SubstanceDruglikenessComponent.propTypes = {
  drugData: PropTypes.object.isRequired,
};
